// extracted by mini-css-extract-plugin
module.exports = {"mainBtn":"Payment_mainBtn__kKs5R","priceContainer":"Payment_priceContainer__2LbI2"};